import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import Loading from '../../components/Loading';

import accountRouter from '../account';

const ConcreteSensorDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "attendance-dashboard" */ '../../pages/concrete-sensor-dashboard'
    ),
);

const concreteSensorDashboardRouter = (
  <Route path="concrete-sensor-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ConcreteSensorDashboardComponent />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default concreteSensorDashboardRouter;
